import axios from "axios";
import { baseURL } from "./endpoints";

const protectedApi = axios.create({ baseURL });
protectedApi.interceptors.request.use(
    (config) => {
        let token = localStorage.getItem("token") ?? ""
        config.headers = {
            // Authorization: `Token ${localStorage.getItem("token")}`,
            Authorization: `Token ${token} `,
            ...config.headers,
        }
        return config
    },
    (err) => Promise.reject(err)
)

export default protectedApi;